function initReveal() {
  const els = document.querySelectorAll('.ph-reveal');
  if (!els.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach((el) => el.classList.add('ph-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('ph-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  els.forEach((el) => observer.observe(el));
}

function initCarruseles() {
  const carruseles = document.querySelectorAll('[data-ph-carrusel]');
  if (!carruseles.length) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  carruseles.forEach((carrusel) => {
    const track = carrusel.querySelector('[data-ph-track]');
    const slides = track ? Array.from(track.children) : [];
    if (!track || slides.length < 2) return;

    const puntos = Array.from(carrusel.querySelectorAll('[data-ph-punto]'));
    const btnPrev = carrusel.querySelector('[data-ph-prev]');
    const btnNext = carrusel.querySelector('[data-ph-next]');
    const autoplay = carrusel.dataset.autoplay === 'true' && !reduceMotion;
    const velocidad = parseInt(carrusel.dataset.velocidad, 10) || 5000;

    let indice = 0;
    let temporizador = null;

    function irA(nuevoIndice) {
      indice = (nuevoIndice + slides.length) % slides.length;
      track.style.transform = `translateX(-${indice * 100}%)`;
      puntos.forEach((punto, i) => punto.classList.toggle('ph-activo', i === indice));
    }

    function siguiente() {
      irA(indice + 1);
    }

    function anterior() {
      irA(indice - 1);
    }

    function iniciarAutoplay() {
      if (!autoplay) return;
      detenerAutoplay();
      temporizador = setInterval(siguiente, velocidad);
    }

    function detenerAutoplay() {
      if (temporizador) clearInterval(temporizador);
    }

    btnNext && btnNext.addEventListener('click', () => {
      siguiente();
      iniciarAutoplay();
    });
    btnPrev && btnPrev.addEventListener('click', () => {
      anterior();
      iniciarAutoplay();
    });
    puntos.forEach((punto) => {
      punto.addEventListener('click', () => {
        irA(parseInt(punto.dataset.phPunto, 10));
        iniciarAutoplay();
      });
    });

    carrusel.addEventListener('mouseenter', detenerAutoplay);
    carrusel.addEventListener('mouseleave', iniciarAutoplay);
    carrusel.addEventListener('focusin', detenerAutoplay);
    carrusel.addEventListener('focusout', iniciarAutoplay);

    let inicioX = null;
    track.addEventListener('touchstart', (e) => {
      inicioX = e.touches[0].clientX;
      detenerAutoplay();
    }, { passive: true });
    track.addEventListener('touchend', (e) => {
      if (inicioX === null) return;
      const deltaX = e.changedTouches[0].clientX - inicioX;
      if (Math.abs(deltaX) > 40) {
        deltaX < 0 ? siguiente() : anterior();
      }
      inicioX = null;
      iniciarAutoplay();
    });

    irA(0);
    iniciarAutoplay();
  });
}

function initCarrucelesProductos() {
  const carruseles = document.querySelectorAll('[data-ph-scroll-carrusel]');
  if (!carruseles.length) return;

  carruseles.forEach((track) => {
    const wrap = track.closest('[data-ph-scroll-wrap]');
    if (!wrap) return;
    const btnPrev = wrap.querySelector('[data-ph-scroll-prev]');
    const btnNext = wrap.querySelector('[data-ph-scroll-next]');

    function pasoScroll() {
      const item = track.querySelector('.ph-producto-item, .ph-testimonio-card');
      const ancho = item ? item.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
      return ancho;
    }

    btnNext && btnNext.addEventListener('click', () => {
      track.scrollBy({ left: pasoScroll(), behavior: 'smooth' });
    });
    btnPrev && btnPrev.addEventListener('click', () => {
      track.scrollBy({ left: -pasoScroll(), behavior: 'smooth' });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initReveal();
  initCarruseles();
  initCarrucelesProductos();
});
